<template>
  <canvas :height="height"></canvas>
</template>

<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['chartData', 'options', 'height'],
  mounted() {
    console.log('BarChart mounted - chartData:', this.chartData)
    console.log('BarChart mounted - options:', this.options)
    this.renderChart(this.chartData, this.options)
  }
}
</script>